import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import * as S from './styled'
import { selectUrlPdf } from '../../../../../utils/getUrlPdf'
import isBrazil from '../../../../../utils/isBrazil'

const Stamps = () => {
  const data = useStaticQuery(graphql`
    query {
      stamps: allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { in: ["cap.jpg", "palc.jpg"] }
        }
      ) {
        edges {
          node {
            id
            name
            publicURL
          }
        }
      }
      pdfs: allFile(filter: { sourceInstanceName: { eq: "pdfs" }, extension: { eq: "pdf" } }) {
        edges {
          node {
            id
            name
            publicURL
          }
        }
      }
    }
  `)
  const isBr = isBrazil()

  const listStamps = data.stamps.edges
  const listPdf = data.pdfs.edges

  return (
    <S.ContainerStamp>
      {listStamps.map((item, index) => (
        <div>
          {index === 0 ? (
            isBr ? (
              <S.ContainerImg
                key={index}
                onClick={() => (listPdf ? window.open(selectUrlPdf('cap', listPdf), '_blank') : '')}
              >
                <img
                  width={150}
                  height={84}
                  src={item.node.publicURL}
                  alt={item.node.name}
                  title={'Cap Accredited'}
                />
              </S.ContainerImg>
            ) : null
          ) : (
            <S.ContainerImg
              key={index}
              onClick={() => (listPdf ? window.open(selectUrlPdf('palc', listPdf), '_blank') : '')}
            >
              <img
                style={{ marginRight: 20 }}
                width={100}
                height={100}
                src={item.node.publicURL}
                alt={item.node.name}
                title={'Palc'}
              />
            </S.ContainerImg>
          )}
        </div>
      ))}
    </S.ContainerStamp>
  )
}

export default Stamps
